import { render, staticRenderFns } from "./ConsolePaymentRecovery.vue?vue&type=template&id=18336dff&scoped=true&"
import script from "./ConsolePaymentRecovery.vue?vue&type=script&lang=js&"
export * from "./ConsolePaymentRecovery.vue?vue&type=script&lang=js&"
import style0 from "./ConsolePaymentRecovery.vue?vue&type=style&index=0&id=18336dff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18336dff",
  null
  
)

export default component.exports